import { styled, Box, Step, StepDescription, StepTitle, Link } from "@chakra-ui/react";

export const SpecialStep = styled(Step, {
	baseStyle: {
		minWidth: 0
	}
});

export const StepInfoWrapper = styled(Box, {
	baseStyle: {
		minWidth: 0
	}
});

export const StepInfoTitle = styled(StepTitle, {
	baseStyle: {
		overflow: "hidden",
		textOverflow: "ellipsis"
	}
});

export const StepInfoDescription = styled(StepDescription, {
	baseStyle: {
		overflow: "hidden",
		textOverflow: "ellipsis"
	}
});

export const DocLink = styled(Link, {
	baseStyle: {
		textDecoration: "underline",
		fontSize: "1rem",
		lineHeight: "17px",
		color: "orange.600"
	}
});
